import { ePageSettingActionTypeIds, IPageSettingActionType } from "../../action-types/common/IPageSettingActions"
import { IPageSettingReducer } from "../../reducer-model/common/IPageSettingReducer"
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase"

const iniState: IPageSettingReducer = {
    status: eReducerStatusBase.is_not_initialization,
    settings: [],
}
export const pageSettingReducer = (state: IPageSettingReducer = iniState, action: IPageSettingActionType) => {
    switch (action.type) {
        case ePageSettingActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case ePageSettingActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                settings: action.payload,
            }
        case ePageSettingActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case ePageSettingActionTypeIds.SAVE_START:
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            }
        case ePageSettingActionTypeIds.SAVE_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            }
        case ePageSettingActionTypeIds.SAVE_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        default:
            return state;
    }
};